import { isMainThread } from "../env.ts";
import { throwUnsupportedRuntimeError } from "../error.ts";
function parallel(module) {
    void module;
    throwUnsupportedRuntimeError();
}
(function (parallel) {
    parallel.maxWorkers = undefined;
    parallel.workerEntry = undefined;
    parallel.isMainThread = false;
})(parallel || (parallel = {}));
Object.defineProperty(parallel, "isMainThread", {
    value: isMainThread,
    writable: false,
});
export default parallel;
//# sourceMappingURL=parallel.js.map